module.exports = __webpack_public_path__ + "static/media/login-image2.e04bf4fa.svg";